
import { Component, Prop, Vue } from "vue-property-decorator";
import axios from "axios";
import Loading from "@/components/Loading.vue";
import { apiURL, environment } from "@/App.vue";
import BadFit from "@/components/Initial/BadFit.vue";
import { CreationResponse } from "../../Models/CreationResponse";
import ResponseModal from "@/components/Initial/ResponseModal.vue";
import { UTMHelper, ReferralRock, Branding } from "@/helper";
import { getCurrentSignupFlow, getSignupBranding } from "@/Models/SignupData";
import { AccountingSystem, InitialSetup } from "@/Models/InitialData";

@Component({
  components: {
    Loading,
    BadFit,
    ResponseModal,
  },
})
export default class InitialForm extends Vue {
  @Prop()
  public initialSetupData!: InitialSetup | null;
  @Prop({ default: false })
  public isSplit!: boolean;
  @Prop()
  public branding!: string;

  public email: string = "";
  public selectedSystem: AccountingSystem | null = null;
  public otherAccountingSystem: string = "";
  public marketingPreference: number = 1;
  public verificationLinkSent: boolean = false;
  public captchaTicked: boolean = false;
  public accountingDefault = {
    Other: "ACCSYSOTHER",
    Unknown: "ACCSYSUNKNOW",
  };
  public formLoading: boolean = false;
  public tandc: boolean = false;
  public recaptchaError: boolean = false;
  public utmQueryString: string = "";

  public created(): void {
    window["captchaTicked"] = () => {
      this.captchaTicked = true;
      this.recaptchaError = false;
    };
    if (UTMHelper.hasUTMParams() || Branding.getBrandingParam()) {
      this.utmQueryString = window.location.search;
    }
  }

  public async mounted() {
    if (window["grecaptcha"] && window["grecaptcha"].render) {
      window["grecaptcha"].render(document.querySelector(".g-recaptcha"));
    }
  }

  public get sortedSystemList() {
    return this.initialSetupData
      ? this.sortAccountingList(this.initialSetupData.AccountingSystems)
      : [];
  }

  public sortAccountingList(list: AccountingSystem[]): AccountingSystem[] {
    return list
      .sort((a, b) => {
        if (a.Description > b.Description) {
          return -1;
        }
        if (a.Description < b.Description) {
          return 1;
        }
        return 0;
      })
      .sort((a, b) => {
        if (a.Id === "ACCSYSUNKNOW" || a.Id === "ACCSYSOTHER") {
          return 1;
        } else {
          return -1;
        }
      });
  }

  get canGoNext(): boolean {
    if (this.selectedSystem && this.tandc && this.captchaTicked) {
      return true;
    } else {
      return false;
    }
  }

  public goNext(): void {
    if (this.canGoNext) {
      this.formLoading = true;
      axios
        .post(apiURL() + "/api/Signup/createContact", {
          Email: this.email,
          Accountsystem: this.selectedSystem,
          Marketing: this.marketingPreference,
          GrecaptchaClientResp: window["grecaptcha"].getResponse(),
          UTMQueryString: this.utmQueryString,
          OtherAccountingSystem: this.otherAccountingSystemSelected
            ? this.otherAccountingSystem
            : undefined,
          SignupFlow: getCurrentSignupFlow(this.$route),
          SignupBranding: getSignupBranding(),
          BackUrl: window.location.href,
        })
        .then((response) => {
          this.handleResponse(response.data);
        })
        .catch((error) => {
          this.formLoading = false;
          this.$emit("handleResponse", {
            Type: "ProfileCreationError",
          } as CreationResponse);
        });
      // Set the referral rock conversion object
      ReferralRock.setConversionObject(this.email, environment());
    }
  }

  public get otherAccountingSystemSelected() {
    return this.selectedSystem && this.selectedSystem.Id === "ACCSYSOTHER";
  }

  public resetRecaptcha(): void {
    window["grecaptcha"].reset();
  }

  public handleResponse(response: CreationResponse): void {
    if (response.Type === "UnsuitableCustomer") {
      this.$emit("toggleBadFit");
    } else if (response.RedirectUri) {
      window.location.href = response.RedirectUri;
    } else {
      this.$emit("handleResponse", response);
      this.resetRecaptcha();
    }
    this.formLoading = false;
  }
}
